<span [ngClass]="status" class="status-badge" [class.filled]="filled === true">{{ 'hub.quotations.status.' + status | translate }}</span>
